module.exports = __webpack_public_path__ + "img/wetz-focus.5b461fe.svg";